// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c4d7480e","455":"080af710","977":"41ed8556"}[chunkId] + ".chunk.js";
};